import React, { useState } from 'react';
import { buildFileUrl, shouldPreviewAsPdf } from '../../utils/fileUtils';
import { PdfPreviewModal } from './PdfPreviewModal';

export const FilePreviewLink = ({ filePath, children, style, className }) => {
  const [modalOpen, setModalOpen] = useState(false);

  if (!filePath) {
    return null;
  }

  const fileUrl = buildFileUrl(filePath);
  const previewAsPdf = shouldPreviewAsPdf(filePath);

  if (!previewAsPdf) {
    return (
      <a href={fileUrl} target="_blank" rel="noreferrer" style={style} className={className}>
        {children}
      </a>
    );
  }

  return (
    <>
      <button
        type="button"
        onClick={() => setModalOpen(true)}
        style={{
          background: 'none',
          border: 'none',
          padding: 0,
          color: '#4183c4',
          cursor: 'pointer',
          textDecoration: 'underline',
          font: 'inherit',
          ...style,
        }}
        className={className}
      >
        {children}
      </button>
      <PdfPreviewModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        filePath={filePath}
      />
    </>
  );
};
